import { MainContentLayout } from 'shared/ui/layout';

import { AddCarBrand } from 'features/car/add-car-brand';

export function AddCarBrandPage() {
  return <MainContentLayout element={<AddCarBrand />} />;
}
